import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import TableAntd from "components/elements/Table";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

const { Modal, Col, Flex, Row, Button } = require("antd")

const PayrollPeriodCalculateDetailsModal = ({
    dataSource = [],
    isLoading = false,
    pagination = {},
    onCancel = () => { },
    onChange = () => { },
    isModalOpen = false,
    // visible = false,
    // handleVisible = () => { }
}) => {
    const [visible, setVisible] = useState();
    const handleVisible = useCallback((value) => {
        setVisible(value)
    }, [])
    const { t, i18n } = useTranslation()
    const columns = [
        {
            title: <div className="text-table">{t("user_management.label.employee_id")}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
        },
        {
            title: <div className="text-table">{t("employee_list.header")}</div>,
            dataIndex: "employeeName",
            key: "employeeName",
            render: (_, record) => {
                return (
                    <Flex >{i18n.language === 'en' ? record?.nameEn + " " + record?.surNameEn : record?.name + " " + record?.surName}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t("salary.label.salary")}</div>,
            dataIndex: "salary",
            key: "salary",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='flex-end'>{visible ? (isNaN(record?.salary) ? "xx,xxx.xx" : get2DecimalPointsWithCommas(record?.salary)) : "xx,xxx.xx"}</Flex>
                    <Flex justify='flex-end'>{visible ? (isNaN(record?.salary) ? "0.00" : get2DecimalPointsWithCommas(record?.salary)) : "xxx,xxx"}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t('payment.label.withholding-tax')}</div>,
            dataIndex: "withholdingTax",
            key: "withholdingTax",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='flex-end'>{visible ? (isNaN(record?.withholdingTax) ? "xx,xxx.xx" : get2DecimalPointsWithCommas(record?.withholdingTax)) : "xx,xxx.xx"}</Flex>
                    <Flex justify='flex-end'>{visible ? (isNaN(record?.withholdingTax) ? "0.00" : get2DecimalPointsWithCommas(record?.withholdingTax)) : "xxx,xxx"}</Flex>
                )
            }

        },
        {
            title: <div className="text-table">{t('payment.label.social_security')}</div>,
            dataIndex: "socialSecurity",
            key: "socialSecurity",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='flex-end'> {visible ? get2DecimalPointsWithCommas(record?.socialSecurity || 0) : "xxxxx.xx"}</Flex>
                    <Flex justify='flex-end'> {visible ? (isNaN(record?.socialSecurity) ? "0.00" : get2DecimalPointsWithCommas(record?.socialSecurity)) : "xxx,xxx"}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t('payment.label.tax')}</div>,
            dataIndex: "taxRate",
            key: "taxRate",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='center'>{visible ? record?.taxRate : "xx,xxx.xx"}</Flex>
                    <Flex justify='center'>{visible ? get2DecimalPointsWithCommas(record?.taxRate, 0) : "xxx,xxx"}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t('payment.label.net_income')}</div>,
            dataIndex: "netIncome",
            key: "netIncome",
            align: 'center',
            render: (_, record) => {
                return (
                    // <Flex justify='flex-end'>{visible ? (isNaN(record?.netIncome) ? "xx,xxx.xx" : get2DecimalPointsWithCommas(record?.netIncome)) : "xx,xxx.xx"}</Flex>
                    <Flex justify='flex-end'>{visible ? (isNaN(record?.netIncome) ? "xxx,xxx" : get2DecimalPointsWithCommas(record?.netIncome)) : "xxx,xxx"}</Flex>
                )
            }
        },
    ];
    return (
        <Modal
            open={isModalOpen}
            onCancel={onCancel}
            footer={() => {
                return (
                    <Row>
                        <Button
                            onClick={onCancel}
                            type="default"
                            style={{ borderRadius: "8px" }}
                        >
                            {t("common.cancel")}
                        </Button>
                    </Row>
                )
            }}
            width={1200}
            centered
            maskClosable={false}
            closable={false}>
            <Row>
                <Col span={24}>
                    <Flex justify="end">
                        {visible ?
                            <EyeInvisibleOutlined onClick={() => handleVisible(false)} style={{ cursor: "pointer" }} /> :
                            <EyeOutlined onClick={() => handleVisible(true)} />}
                    </Flex>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <TableAntd
                        rowSelection={false}
                        className={{
                            "background- color": "#EAEFF5",
                        }}
                        style={{
                            border: '1px solid lightgray',
                            borderRadius: "8px",
                            width: "100%",
                        }}
                        loading={isLoading}
                        pagination={{
                            ...pagination,
                            showTotal: (total, range) =>
                                t("paginate.description")
                                    .replace("{min}", range[0])
                                    .replace("{max}", range[1])
                                    .replace("{total}", total),
                        }}
                        dataSource={dataSource}
                        rowKey={(record) => record?.txnPaymentId}
                        columns={columns}
                        onChange={onChange}
                        scroll={{ x: true }}

                    />
                </Col>
            </Row>
        </Modal>
    )
}

export default PayrollPeriodCalculateDetailsModal